<template>
  <div class="ph-host">
    <!-- MOBILE -->
    <div class="m-wrap">
      <div class="m-hero">
        <img class="m-bg" :src="bgSrc" alt="" />

        <div class="m-title">
          <div class="m-title__line1">{{ $t('Philippines Cockfighting') }}</div>
          <div class="m-title__line2">{{ $t('Challenge Rules') }}</div>
        </div>

        <div class="m-hero-label m-hero-label--left">{{ $t('Banker / Meron') }}</div>
        <div class="m-hero-label m-hero-label--right">{{ $t('Player / Wala') }}</div>
      </div>

      <div class="m-card">
        <div class="m-card__title">{{ $t('Draw / No Winner') }}</div>
        <div class="m-card__subtitle">{{ $t('A match is declared DRAW (NO WINNER) if:') }}</div>

        <div class="m-card__grid">
        <!-- (1,1) -->
            <img class="m-left-art" :src="leftArtSrc" alt="" />

        <!-- (1,2) -->
            <div class="m-bulletrow">
                <img class="m-bullet" :src="checkBulletSrc" alt="" />
                <span class="m-list__text">
                {{ $t('During the Carreo Procedure (3 UP & 3 DOWN), neither rooster lands two (2) successful pecks, or') }}
                </span>
            </div>

        <!-- (2,1) -->
            <img class="m-timer" :src="timerSrc" alt="" />

        <!-- (2,2) -->
            <div class="m-bulletrow">
                <img class="m-bullet" :src="checkBulletSrc" alt="" />
                <span class="m-list__text">
                {{ $t('No winner is declared within 10 minutes from the first contact.') }}
                </span>
            </div>
        </div>

        <div class="m-footnote">{{ $t('*Arena Judge decision is final.') }}</div>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: 'PhRules',
        data() {
            return {
                bgSrc: require('@/assets/images/game-help/ph-bg-mobile.webp'),
                leftArtSrc: require('@/assets/images/game-help/draw.webp'),
                timerSrc: require('@/assets/images/game-help/10min.webp'),
                checkBulletSrc: require('@/assets/svg/game-help/check-bullet.svg'),
            };
        },
    };
</script>

<style lang="scss" scoped>

    .ph-host {
        width: 100%;
        position: relative;
        overflow: visible;
    }

    .m-wrap {
        width: 100%;
        box-sizing: border-box;
        color: #fff;
        container-type: inline-size;
    }

    /* Hero image area */
    .m-hero {
        position: relative;
        width: 100%;
        overflow: hidden;
        aspect-ratio: 215 / 294;
    }

    .m-bg {
        position: absolute;
        inset: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    /* Title */
    .m-title {
        position: absolute;
        top: 2%;
        left: 0;
        right: 0;
        text-align: center;
        text-transform: uppercase;
        text-shadow: 0 6px 18px rgba(0, 0, 0, 0.7);
    }

    .m-title__line1 {
        font-weight: 900;
        letter-spacing: 0.03em;
        font-size: 5.8cqw;
        color: #f2c36b;
    }

    .m-title__line2 {
        font-weight: 900;
        letter-spacing: 0.04em;
        font-size: 4.6cqw;
        color: #ffffff;
        line-height: 1.05;
    }

    /* Banker / Player labels */
    .m-hero-label {
        position: absolute;
        top: 33%;
        font-weight: 900;
        font-size: 4cqw;
        text-transform: uppercase;
        padding: 4px 8px;
    }

    .m-hero-label--left {
        left: 4%;
        color: #e66262;
    }

    .m-hero-label--right {
        right: 4%;
        color: #4d83ff;
    }

    /* Bottom card like screenshot */
    .m-card {
        position: absolute;
        top: 44%;
        padding: 0 12px;
    }

    .m-card__title {
        text-align: center;
        font-weight: 900;
        letter-spacing: 0.06em;
        text-transform: uppercase;
        font-size: 4cqw;
        margin-bottom: 6px;
    }

    .m-card__subtitle {
        text-align: center;
        font-size: 2.6cqw;
        font-weight: 700;
        color: rgba(255, 255, 255, 0.88);
    }

    .m-card__grid {
        display: grid;
        grid-template-columns: 40cqw 1fr;
        /* left column images, right column text */
        grid-template-rows: auto auto;
        column-gap: 12px;
        row-gap: 10px;
    }

    /* Make each bullet row self-contained (icon + text) */
    .m-bulletrow {
        display: grid;
        grid-template-columns: 5cqw 1fr;
        gap: 8px;
        align-items: center;
    }

    /* Keep your existing sizes */
    .m-left-art {
        width: 40cqw !important;
        height: auto;
        object-fit: contain;
    }

    .m-timer {
        width: 18cqw;
        height: auto;
        justify-self: center;
        /* centered under the roosters */
        object-fit: contain;
    }

    /* Bullet + text */
    .m-bullet {
        width: 5cqw !important;
        height: 5cqw !important;
        margin-top: 1px;
        user-select: none;
        pointer-events: none;
    }

    .m-list__text {
        font-size: 2.6cqw;
        font-weight: 700;
        line-height: normal;
        color: rgba(255, 255, 255, 0.9);
    }


    /* footnote */
    .m-footnote {
        top: 100%;
        left: 0;
        right: 0;
        margin-top: 3.8cqw;
        position: absolute;
        text-align: center;
        font-size: 2.4cqw;
        font-weight: 700;
        color: rgba(255, 255, 255, 0.82);
    }
</style>